import React, { useEffect, useMemo, useRef, useState } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineDot from '@mui/lab/TimelineDot';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import TypingEffect from '../AuthUI/TypingEffect';
import MarkdownComponent from './MarkdownComponent';

const CustomizedTimeline = ({ messages }) => {
  const markdownsRef = useRef([]);

  const timelineItems = useMemo(() => {
    const assistant_messages = messages.filter(message => message.role === "assistant")
      return messages.map((item, index) => (
        <TimelineItem key={index} sx={{ height: 450, width: '100%', alignItems: 'center', justifyContent: 'center' }}>
          <TimelineContent sx={{ py: '12px', px: 2, width: '100%', alignContent: 'center', position: 'relative' }}>
            {item.role === 'assistant' &&<TypingEffect text={item.metadata?item.metadata.title:null} speed={30} />}
            <Typography
              sx={{
                height: 'calc(33vh + 5vh)',
                // zIndex: 2001,
                paddingLeft: '5px',
                paddingRight: '12px',
                position: 'relative',
                alignContent: 'center',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                textAlign: '-webkit-center',
              }}
            >
              {item.content !== 'empty'?<MarkdownComponent 
                markdown={item.content} 
                ref={el => markdownsRef.current[item.id] = el} 
                audio={item.audio}
                id={item.id} />:<Stack><Stack sx={{
                  padding: '5px',
                  borderRadius: '10px',
                  border: 'solid 1px white',
                  background: 'linear-gradient(34deg, rgba(106, 106, 106, 0.9) 0%, rgba(87, 82, 82, 0.9) 100%)',
                  boxShadow: '2px 3px 12px 0px rgb(0 0 0)',
                  marginBottom: '0.5rem',
                  whiteSpace: 'pre-wrap',
                }} spacing={1}>
                  <Box sx={{ width: '95%' }}>
                    <Skeleton />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation={false} />
                  </Box>

                {/* <Skeleton variant="text" marginTop={0} width={330} sx={{ fontSize: '1.1rem' }} /> */}
              </Stack>
              <Stack sx={{
                  padding: '5px',
                  borderRadius: '10px',
                  border: 'solid 1px white',
                  background: 'linear-gradient(34deg, rgba(106, 106, 106, 0.9) 0%, rgba(87, 82, 82, 0.9) 100%)',
                  boxShadow: '2px 3px 12px 0px rgb(0 0 0)',
                  marginBottom: '0.5rem',
                  whiteSpace: 'pre-wrap',
                }} spacing={1}>
                <Box sx={{ width: '95%' }}>
                  <Skeleton />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation={false} />
                </Box>

                {/* <Skeleton variant="text" marginTop={0} width={330} sx={{ fontSize: '1.1rem' }} /> */}
              </Stack>
              </Stack>}
              
              
            </Typography>
          </TimelineContent>
        </TimelineItem>
      ));
  }, [messages]);

  return (
    <Card
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
        background: 'none',
        height: 'fit-content',
        width: '100%',
        position: 'relative',
        paddingTop: 1,
        paddingBottom: 0,
        paddingRight: 0,
        paddingLeft: 0,
        justifyContent: 'center',
      }}
      position="left"
    >
      {timelineItems}
    </Card>
  );
};

export default CustomizedTimeline;